import React, { CSSProperties, memo } from 'react';
import { areEqual } from 'react-window';

import { PhotoShootImageData } from 'apis/mips/types';

import { DraggableImageTile } from '../ImageTile/DraggableImageTile';

type ImagesGalleryCellRenderer = {
  data: (PhotoShootImageData & {
    columnCount: number;
    rowCount: number;
    onDelete: (imageId: string) => void;
    isDeleting?: boolean;
    isReadOnly?: boolean;
    isLinked?: boolean;
  })[];
  rowIndex: number;
  columnIndex: number;
  style: CSSProperties;
};
const ImagesGalleryCellRenderer = ({ rowIndex, columnIndex, data, style }: ImagesGalleryCellRenderer) => {
  const idx = rowIndex * data[0].columnCount + columnIndex;
  const image = data[idx];

  const isFirstRow = rowIndex === 0;
  const isLastRow = rowIndex === data[0].rowCount - 1;
  const isLastColumn = columnIndex === data[0].columnCount - 1;
  const isFirstColumn = columnIndex === 0;

  if (!image) {
    return null;
  }

  return (
    <div
      style={{
        ...style,
        paddingTop: isFirstRow ? 0 : 4,
        paddingBottom: isLastRow ? 8 : 4,
        paddingLeft: isFirstColumn ? 0 : 4,
        paddingRight: isLastColumn ? 0 : 4,
        boxSizing: 'border-box',
      }}
    >
      <DraggableImageTile
        key={image.id}
        image={image}
        onDelete={image.onDelete}
        isDeleting={image.isDeleting}
        isLinked={image.isLinked}
        isReadOnly={image.isReadOnly}
      />
    </div>
  );
};

export default memo(ImagesGalleryCellRenderer, areEqual);
